 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d":"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d","@walletconnect/universal-provider":"@walletconnect/universal-provider","private-pages~public-page-customers~public-page-vacancies":"private-pages~public-page-customers~public-page-vacancies","public-page-customers":"public-page-customers","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies","private-pages~public-page-jobs":"private-pages~public-page-jobs","private-pages":"private-pages","public-page-jobs~public-page-vacancies":"public-page-jobs~public-page-vacancies","public-page-vacancies":"public-page-vacancies","public-page-freelancers~public-page-gigs":"public-page-freelancers~public-page-gigs","public-page-freelancers":"public-page-freelancers","public-page-gigs":"public-page-gigs","public-page-jobs":"public-page-jobs","public-page-about":"public-page-about","public-page-blog":"public-page-blog","public-page-landing":"public-page-landing","public-page-mining":"public-page-mining","public-page-premium":"public-page-premium","public-page-skills":"public-page-skills","salary-pages":"salary-pages","@walletconnect/web3-provider~web3~web3-utils":"@walletconnect/web3-provider~web3~web3-utils","web3-utils":"web3-utils","@walletconnect/web3-provider~web3":"@walletconnect/web3-provider~web3","web3":"web3","add-role-modal":"add-role-modal","cash-modals~job-modals":"cash-modals~job-modals","cash-modals":"cash-modals","ckeditor":"ckeditor","date-picker":"date-picker","erc20-lht-v1":"erc20-lht-v1","erc20-v1.json":"erc20-v1.json","image-cropper":"image-cropper","lx-analytics":"lx-analytics","lx-contract-v1":"lx-contract-v1","lx-contract-v2":"lx-contract-v2","public-page-landing-copy":"public-page-landing-copy","qr-code":"qr-code","recaptcha":"recaptcha","sentry":"sentry","settings-modals":"settings-modals","swiper":"swiper","time-warp-pool":"time-warp-pool","vue-slider-component":"vue-slider-component","welcome-modal":"welcome-modal","skills-modals":"skills-modals","job-modals":"job-modals","jobs-modals":"jobs-modals","gig-modals":"gig-modals","share-modal":"share-modal","application-modal":"application-modal","@walletconnect/web3-provider":"@walletconnect/web3-provider","stack-grid":"stack-grid"}[chunkId]||chunkId) + "-legacy." + {"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d":"50a39ae0","@walletconnect/universal-provider":"54be06b4","private-pages~public-page-customers~public-page-vacancies":"77408f9c","public-page-customers":"0090422c","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"327cdc9e","private-pages~public-page-jobs":"b851c921","private-pages":"6d753933","public-page-jobs~public-page-vacancies":"d7fc9a6f","public-page-vacancies":"04aa5b29","public-page-freelancers~public-page-gigs":"f4840f61","public-page-freelancers":"44016005","public-page-gigs":"aedb2597","public-page-jobs":"98892087","public-page-about":"e7ca5898","public-page-blog":"6193afff","public-page-landing":"2fedb491","public-page-mining":"a4b1a054","public-page-premium":"dc27f12d","public-page-skills":"b474ede0","salary-pages":"7d5a300c","@walletconnect/web3-provider~web3~web3-utils":"801829b2","web3-utils":"9b75af01","@walletconnect/web3-provider~web3":"a652f3b2","web3":"10889713","add-role-modal":"e5fb03c5","cash-modals~job-modals":"542fa8de","cash-modals":"159c6341","ckeditor":"686819bf","date-picker":"74f81878","erc20-lht-v1":"9ab7308e","erc20-v1.json":"aed71b84","image-cropper":"7b77808e","lx-analytics":"f1aa3390","lx-contract-v1":"dc6e735e","lx-contract-v2":"47534421","public-page-landing-copy":"3495bcbf","qr-code":"c94a25fe","recaptcha":"d35f8c81","sentry":"42dad18d","settings-modals":"8d885e48","swiper":"9c7befeb","time-warp-pool":"18067f89","vue-slider-component":"29a7d604","welcome-modal":"56488687","skills-modals":"1b1d8b39","job-modals":"d239001f","jobs-modals":"72f72d8c","gig-modals":"25744457","share-modal":"c71d975f","application-modal":"18ce6c2a","@walletconnect/web3-provider":"8f965ab9","stack-grid":"ac89ba30"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"private-pages~public-page-customers~public-page-vacancies":1,"public-page-customers":1,"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":1,"private-pages~public-page-jobs":1,"private-pages":1,"public-page-jobs~public-page-vacancies":1,"public-page-vacancies":1,"public-page-freelancers~public-page-gigs":1,"public-page-freelancers":1,"public-page-gigs":1,"public-page-jobs":1,"public-page-about":1,"public-page-blog":1,"public-page-landing":1,"public-page-mining":1,"public-page-premium":1,"public-page-skills":1,"salary-pages":1,"add-role-modal":1,"cash-modals~job-modals":1,"cash-modals":1,"ckeditor":1,"date-picker":1,"image-cropper":1,"public-page-landing-copy":1,"settings-modals":1,"welcome-modal":1,"skills-modals":1,"job-modals":1,"jobs-modals":1,"gig-modals":1,"share-modal":1,"application-modal":1,"stack-grid":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d":"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d","@walletconnect/universal-provider":"@walletconnect/universal-provider","private-pages~public-page-customers~public-page-vacancies":"private-pages~public-page-customers~public-page-vacancies","public-page-customers":"public-page-customers","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies","private-pages~public-page-jobs":"private-pages~public-page-jobs","private-pages":"private-pages","public-page-jobs~public-page-vacancies":"public-page-jobs~public-page-vacancies","public-page-vacancies":"public-page-vacancies","public-page-freelancers~public-page-gigs":"public-page-freelancers~public-page-gigs","public-page-freelancers":"public-page-freelancers","public-page-gigs":"public-page-gigs","public-page-jobs":"public-page-jobs","public-page-about":"public-page-about","public-page-blog":"public-page-blog","public-page-landing":"public-page-landing","public-page-mining":"public-page-mining","public-page-premium":"public-page-premium","public-page-skills":"public-page-skills","salary-pages":"salary-pages","@walletconnect/web3-provider~web3~web3-utils":"@walletconnect/web3-provider~web3~web3-utils","web3-utils":"web3-utils","@walletconnect/web3-provider~web3":"@walletconnect/web3-provider~web3","web3":"web3","add-role-modal":"add-role-modal","cash-modals~job-modals":"cash-modals~job-modals","cash-modals":"cash-modals","ckeditor":"ckeditor","date-picker":"date-picker","erc20-lht-v1":"erc20-lht-v1","erc20-v1.json":"erc20-v1.json","image-cropper":"image-cropper","lx-analytics":"lx-analytics","lx-contract-v1":"lx-contract-v1","lx-contract-v2":"lx-contract-v2","public-page-landing-copy":"public-page-landing-copy","qr-code":"qr-code","recaptcha":"recaptcha","sentry":"sentry","settings-modals":"settings-modals","swiper":"swiper","time-warp-pool":"time-warp-pool","vue-slider-component":"vue-slider-component","welcome-modal":"welcome-modal","skills-modals":"skills-modals","job-modals":"job-modals","jobs-modals":"jobs-modals","gig-modals":"gig-modals","share-modal":"share-modal","application-modal":"application-modal","@walletconnect/web3-provider":"@walletconnect/web3-provider","stack-grid":"stack-grid"}[chunkId]||chunkId) + "." + {"@walletconnect/universal-provider~private-pages~public-page-about~public-page-blog~public-page-custo~f99dcb7d":"31d6cfe0","@walletconnect/universal-provider":"31d6cfe0","private-pages~public-page-customers~public-page-vacancies":"d906edc1","public-page-customers":"4be09481","private-pages~public-page-freelancers~public-page-gigs~public-page-jobs~public-page-vacancies":"428808e3","private-pages~public-page-jobs":"694243c3","private-pages":"0f81b17d","public-page-jobs~public-page-vacancies":"ce14b66d","public-page-vacancies":"c75f5013","public-page-freelancers~public-page-gigs":"86950697","public-page-freelancers":"f614b781","public-page-gigs":"437f22fa","public-page-jobs":"41a9dd17","public-page-about":"d26f4371","public-page-blog":"03f9b494","public-page-landing":"0a8a7ddc","public-page-mining":"c3aba7cd","public-page-premium":"d4b0577b","public-page-skills":"e2cd4701","salary-pages":"4a8d7a89","@walletconnect/web3-provider~web3~web3-utils":"31d6cfe0","web3-utils":"31d6cfe0","@walletconnect/web3-provider~web3":"31d6cfe0","web3":"31d6cfe0","add-role-modal":"ea7004bd","cash-modals~job-modals":"480272e1","cash-modals":"78a79b06","ckeditor":"5466a9e6","date-picker":"783cec79","erc20-lht-v1":"31d6cfe0","erc20-v1.json":"31d6cfe0","image-cropper":"523ffe84","lx-analytics":"31d6cfe0","lx-contract-v1":"31d6cfe0","lx-contract-v2":"31d6cfe0","public-page-landing-copy":"5a96cc18","qr-code":"31d6cfe0","recaptcha":"31d6cfe0","sentry":"31d6cfe0","settings-modals":"e1866b33","swiper":"31d6cfe0","time-warp-pool":"31d6cfe0","vue-slider-component":"31d6cfe0","welcome-modal":"98858097","skills-modals":"e95f844a","job-modals":"1c3fcab7","jobs-modals":"feda04b9","gig-modals":"acfe38e7","share-modal":"faf29262","application-modal":"483e2994","@walletconnect/web3-provider":"31d6cfe0","stack-grid":"664b77f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
